import { getQuantidadeAgendados } from './functions.js'

/**
 * Filtra a lista de cadastros conforme os filtros selecionados.
 *
 * @param {Array<Object>} cadastros Lista de cadastros a serem filtrados.
 * @param {Boolean} exibirVermelhos Indica se devem ser exibidos apenas os cadastros vermelhos.
 * @param {Boolean} exibirVerdes Indica se devem ser exibidos apenas os cadastros verdes.
 * @param {Object} equipe Equipe selecionada.
 * @param {Object|null} mes Mês selecionado no filtro.
 *
 * @returns {Array<Object>} Lista de cadastros filtrados.
 */
export function filtro(
  cadastros,
  exibirVermelhos,
  exibirVerdes,
  equipe = null,
  mes = null
) {
  let cadastros_filtrados = cadastros || []

  if (exibirVermelhos === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      const maisAcesso = item.num_mais_acesso <= 0

      if (!mes) {
        return maisAcesso
      }

      const temEspontaneoNoPeriodo =
        getQuantidadeAgendados(item, mes, true, false, equipe) >= 1

      return maisAcesso && temEspontaneoNoPeriodo
    })
  }

  if (exibirVerdes === true) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      // Só exibe quem tem ao menos 1 atendimento por agendamento
      // no período e na equipe selecionados.
      return getQuantidadeAgendados(item, mes, false, true, equipe) >= 1
    })
  }

  // Sem filtro de tipo + período: só quem tem espontâneo e/ou agendado no período.
  if (!exibirVermelhos && !exibirVerdes && mes) {
    cadastros_filtrados = cadastros_filtrados.filter((item) => {
      return getQuantidadeAgendados(item, mes, false, false, equipe) >= 1
    })
  }

  return cadastros_filtrados
}
